import Toggle from "react-toggle";

function ToggleSetting(props) {
    return (
        <div className="toggle-setting">
            {props.title ? props.title : ''}
            <Toggle 
                className={'toggle-switch'} 
                icons={false}
                onChange={props.onChange}
            />
        </div>
    )
}

export default ToggleSetting;